export enum FORMIK_TEXT_FIELD_TYPE {
  TEXT = 'text',
  PASSWORD = 'password',
}

export default { FORMIK_TEXT_FIELD_TYPE };
